import { createFileRoute } from '@tanstack/react-router'
import MakeLocalDataPage from '@/pages/MakeLocalDataPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/local-data')({
  component: MakeLocalDataPage,
})
